import React, {useEffect} from 'react';
import YorhaBitmovin from '@tides/yorha-react';
import {useSelector} from 'react-redux';
import {useRouteMatch} from 'react-router';
import Lottie from 'lottie-web';

import {selectCanAutoPlayVideo} from '../../store/reducers';
import {oneTrustEnabled} from '../../utils/onetrust';
import NitoLoader from '../../assets/animations/cnito_loader_1.json';
// eslint-disable-next-line max-len
import CNLoaderRefreshed from '../../assets/animations/CNApp_Refreshed_Loader.json';
import DkidsLoader from './../../assets/animations/dkids-loader-mvp.json';
import {useBrand} from '../../helpers';

const PurePlayer = ({
    content,
    setPlayerReady,
    setAdStarted,
    refCallback,
    muted,
    noAdvertising,
    ...props
}) => {
    const {
        params: {live_id},
    } = useRouteMatch();
    const {user, config} = useSelector(state => state);
    const idp = user && user.idp;
    const tve = user && user.user_type === 'tve';
    const playerRef = React.useRef();
    const brand = useBrand();

    /*const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        window.addEventListener('focus', () => {
            !isFocused && setIsFocused(true);
        });
        window.addEventListener('click', () => {
            !isFocused && setIsFocused(true);
        });

        // eslint-disable-next-line
    }, []);*/

    const isFocused = useSelector(selectCanAutoPlayVideo);

    useEffect(() => {
        refCallback && refCallback(playerRef.current);

        // eslint-disable-next-line
    }, [playerRef.current]);

    let adTagUrl = undefined;

    if (!noAdvertising) {
        if (config.player_settings && config.player_settings.ads) {
            adTagUrl = tve
                ? config.player_settings.ads.tveAd
                : config.player_settings.ads.telcoAd;

            if (config.btw && config.btw.enabled && !user.jwtToken) {
                adTagUrl =
                    config.player_settings.ads.tveAd ||
                    config.player_settings.ads.telcoAd;
            }

            if (brand === 'cnito') {
                adTagUrl = `https://pubads.g.doubleclick.net/gampad/ads?sz=970x250%7C320x50%7C300x250%7C728x90%7C640x480&iu=/99911224/ci_[countryname]la&env=vp&impl=s&gdfp_req=1&output=vast&unviewed_position_start=1&description_url=http%3A%2F%2Fwww.cartoonitola.com&correlator=`;
            } else if (brand === 'dkids') {
                adTagUrl = undefined;
            }
        }

        if (adTagUrl && adTagUrl.indexOf('[countryname]')) {
            if (user.countryIsoCode) {
                adTagUrl = adTagUrl.replace(
                    '[countryname]',
                    ['ar', 'br', 'co', 'cl', 'mx', 've'].includes(
                        user.countryIsoCode.toLowerCase(),
                    )
                        ? user.countryIsoCode.toLowerCase()
                        : 'la',
                );
            } else {
                adTagUrl = undefined;
            }
        }
    }

    return (
        <YorhaBitmovin
            id={content.id}
            ref={playerRef}
            autoplay
            muted={!isFocused || muted}
            chromecast={false}
            chromecastReceiverId={config.player_settings.chromecast.receiverId}
            chromecastParams={
                content && {
                    metadata: {
                        seriesTitle: content.description,
                    },
                    streamType: 'LIVE',
                    customData: {
                        contentId: content.id,
                        brand: 'CNPLUS',
                        device: 'PCTV',
                        JWTToken: user.jwtToken,
                        region: user.catalogTenant,
                    },
                }
            }
            customErrors={{
                1400: 'AAAHHHH NOOOOOOOO',
            }}
            // eslint-disable-next-line max-len
            customStyle="https://cn.i.cdn.ti-platform.com/static/cnplus/cartoon-plus-reface.css"
            eventHandlers={{
                onReady: () => {
                    configureStallIndicator(brand);
                },

                onPlay: () => {
                    setPlayerReady(true);
                },

                onAdStarted: event => {
                    setPlayerReady(true);

                    setAdStarted(true);
                },
                onAdSkipped: () => {
                    window.turner_metadata.trackAction.push({
                        type: 'video',
                        subtype: 'Ad_Skipped',
                        data: {
                            platform: 'web',
                            content_name: content && content.title,
                            content_id: live_id || content.id,
                            content_type: 'live',

                            authstate:
                                user && user.jwtToken
                                    ? 'authenticated'
                                    : 'unauthenticated',
                            mvpd: idp || 'idp not loaded',
                            logintype: user.user_type,
                        },
                    });
                },

                onAdFinished: () => {
                    window.turner_metadata.trackAction.push({
                        type: 'video',
                        subtype: 'Ad_Finished',
                        data: {
                            platform: 'web',
                            content_name: content && content.title,
                            content_id: live_id || content.id,
                            content_type: 'live',

                            authstate:
                                user && user.jwtToken
                                    ? 'authenticated'
                                    : 'unauthenticated',
                            mvpd: idp || 'idp not loaded',
                            logintype: user.user_type,
                        },
                    });
                },

                onPlaying: () => {
                    window.turner_metadata.trackAction.push({
                        type: 'video',
                        subtype: 'Media_Started',
                        data: {
                            authstate:
                                user && user.jwtToken
                                    ? 'authenticated'
                                    : 'unauthenticated',
                            mvpd: idp || 'idp not loaded',
                        },
                    });
                },

                onStallStarted: () => {
                    window.turner_metadata.trackAction.push({
                        type: 'video',
                        subtype: 'Media_Buffering_Started',
                        data: {
                            authstate:
                                user && user.jwtToken
                                    ? 'authenticated'
                                    : 'unauthenticated',
                            mvpd: idp || 'idp not loaded',
                        },
                    });
                },

                onStallEnded: () => {
                    window.turner_metadata.trackAction.push({
                        type: 'video',
                        subtype: 'Media_Buffering_Finished',
                        data: {
                            authstate:
                                user && user.jwtToken
                                    ? 'authenticated'
                                    : 'unauthenticated',
                            mvpd: idp || 'idp not loaded',
                        },
                    });
                },

                onPause: () => {
                    window.turner_metadata.trackAction.push({
                        type: 'video',
                        subtype: 'Media_Paused',
                        data: {
                            authstate:
                                user && user.jwtToken
                                    ? 'authenticated'
                                    : 'unauthenticated',
                            mvpd: idp || 'idp not loaded',
                        },
                    });
                },

                onPlaybackFinished: () => {
                    window.turner_metadata.trackAction.push({
                        type: 'video',
                        subtype: 'Media_Finished',
                        data: {
                            authstate:
                                user && user.jwtToken
                                    ? 'authenticated'
                                    : 'unauthenticated',
                            mvpd: idp || 'idp not loaded',
                        },
                    });
                },
            }}
            isLive={
                (live_id || content.id).indexOf('freelive') >= 0 ||
                (live_id || content.id).indexOf('toontubers') >= 0
                    ? false
                    : true
            }
            license="59be50ed-f8b4-4ee3-8ec4-c24560a462ff"
            preferredLanguage={
                window.location.origin.includes('.br') ? 'POR' : 'SPA'
            }
            source={{
                hls: content?.src,
            }}
            oneTrust={oneTrustEnabled()}
            youboraConfig={{
                accountCode:
                    config.player_settings.analytics &&
                    config.player_settings.analytics.youboraAccount
                        ? config.player_settings.analytics.youboraAccount
                        : 'turnerlatam',
                contentIsLive: true,
                contentTitle: content.description,
                contentId: live_id || content.id,
                username: idp,
                extraparams: {
                    extraparam1: 'Cartoon Network',
                },
            }}
            fairplayLAUrl={
                config.player_settings.drm.fairplay &&
                config.player_settings.drm.fairplay.LA_URL
            }
            fairplayCertificateUrl={
                config.player_settings.drm.fairplay &&
                config.player_settings.drm.fairplay.certificateURL
            }
            localeSettings={{
                localeLanguage: window.location.origin.includes('.br')
                    ? 'pt-BR'
                    : 'es-ES',
            }}
            adTagUrl={adTagUrl}
        />
    );
};

export const configureStallIndicator = brand => {
    const stallIndicator = document.getElementById('yui-stall-indicator');

    if (stallIndicator) {
        Lottie.loadAnimation({
            container: document.getElementById('yui-stall-indicator'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData:
                brand === 'cnito'
                    ? NitoLoader
                    : brand === 'dkids'
                    ? DkidsLoader
                    : CNLoaderRefreshed,
            isClickToPauseDisabled: true,
            isStopped: false,
            isPaused: false,
        });
    }
};

export default PurePlayer;
